import { render, staticRenderFns } from "./VFieldEmail.vue?vue&type=template&id=78b6e678&"
import script from "./VFieldEmail.vue?vue&type=script&lang=js&"
export * from "./VFieldEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b6e678')) {
      api.createRecord('78b6e678', component.options)
    } else {
      api.reload('78b6e678', component.options)
    }
    module.hot.accept("./VFieldEmail.vue?vue&type=template&id=78b6e678&", function () {
      api.rerender('78b6e678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VForm/VFieldEmail.vue"
export default component.exports